// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"SendResultsByEmail_iconSync__2JQAD","fa-spin":"SendResultsByEmail_fa-spin__Zo-Az","accordionHeader":"SendResultsByEmail_accordionHeader__3mr-D"};